import React from "react";
import { Dropdown } from "@fdoh/health-ui-react";
import { Link } from "react-router-dom";
// import { useData } from "./hooks";

const IconLifebuoy = React.lazy(
  () => import("./icons/IconLifebouy" /* webpackChunkName: "IconLifebuoy" */)
);

const IconHelp = React.lazy(
  () => import("./icons/IconHelp" /* webpackChunkName: "IconHelp" */)
);

const IconUser = React.lazy(
  () => import("./icons/IconUser" /* webpackChunkName: "IconUser" */)
);

const IconUsers = React.lazy(
  () => import("./icons/IconUsers" /* webpackChunkName: "IconUsers" */)
);

const IconVideo = React.lazy(
  () => import("./icons/IconVideo" /* webpackChunkName: "IconVideo" */)
);

export const UserMenu = () => {
  // const roles = useData<string[]>("me/roles");

  return (
    <>
      {/* <Dropdown.Header>Settings</Dropdown.Header> */}
      {/* <Link to="/" className="dropdown-item">
        <IconUsers />
        <span className="ml-2">Delegates</span>
      </Link>
      <Link to="/me" className="dropdown-item">
        <IconUser />
        <span className="ml-2">Update Profile</span>
      </Link> */}
      {/* <Dropdown.Header>Help & Documentation</Dropdown.Header>
      <a
        href="https://floridahealth.sharepoint.com/sites/DISEASECONTROL/DCHP_MIS/How%20To/Forms/AllItems.aspx?RootFolder=%2Fsites%2FDISEASECONTROL%2FDCHP%5FMIS%2FHow%20To%2FWorkflow%20Manager%2FGeneral%20User%20Guides&FolderCTID=0x01200057A986A84DC62C41A60987A6E86FD042&View=%7BE53A0F4E%2DB178%2D49A4%2DAE64%2D32C0E1AF7ECE%7D"
        className="dropdown-item"
        target="_blank"
        rel="noreferrer"
      >
        <IconHelp />
        <span className="ml-2">User Documentation</span>
      </a>
      <a
        href="https://floridahealth.sharepoint.com/sites/DISEASECONTROL/DCHP_MIS/How%20To/Forms/AllItems.aspx?RootFolder=%2Fsites%2FDISEASECONTROL%2FDCHP%5FMIS%2FHow%20To%2FWorkflow%20Manager%2FTraining%20Videos&FolderCTID=0x01200057A986A84DC62C41A60987A6E86FD042&View=%7BE53A0F4E%2DB178%2D49A4%2DAE64%2D32C0E1AF7ECE%7D"
        className="dropdown-item"
        target="_blank"
        rel="noreferrer"
      >
        <IconVideo />
        <span className="ml-2">Training Videos</span>
      </a>
      {(roles?.includes("Global Administrator") ||
        roles?.includes("Division Administrator")) && (
        <a
          href="https://floridahealth.sharepoint.com/sites/DISEASECONTROL/DCHP_MIS/How%20To/Forms/AllItems.aspx?RootFolder=%2Fsites%2FDISEASECONTROL%2FDCHP%5FMIS%2FHow%20To%2FWorkflow%20Manager%2FAdministration%20Guides&FolderCTID=0x01200057A986A84DC62C41A60987A6E86FD042&View=%7BE53A0F4E%2DB178%2D49A4%2DAE64%2D32C0E1AF7ECE%7D"
          className="dropdown-item"
          target="_blank"
          rel="noreferrer"
        >
          <IconLifebuoy />
          <span className="ml-2">Admin Documentation</span>
        </a>
      )} */}
    </>
  );
};

export default UserMenu;
